import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { AnalyticsService, ConfigurationService } from '@niceltd/cxone-client-platform-services';

@Component({
    selector: 'cv-gainsight-injector',
    templateUrl: './gainsight-injector.component.html',
    styleUrls: ['./gainsight-injector.component.scss']
})
export class GainsightInjectorComponent implements OnInit {
    @Input() gainsightEnabled: boolean | string;

    constructor(
        private navigationService: NavigationService,
        private cxAnalytics: AnalyticsService,
    ) { }

    ngOnInit(): void {
        if (typeof this.gainsightEnabled === 'string')
            this.gainsightEnabled = this.gainsightEnabled.toLowerCase() === 'true';

        if (!!this.gainsightEnabled) {
            const values = this.navigationService.cxoneAnalyticsValues;
            if (values != null) {
                ConfigurationService.instance.set(ConfigurationService.COMMON_KEYS.ApiServerBaseUrl,
                    this.navigationService.cxoneTokenUrls.niceBaseUrl);
                ConfigurationService.instance.set(ConfigurationService.COMMON_KEYS.AreaIdentifier, values.areaID);
                this.cxAnalytics.inject(values.userID, values.orgName, values.role,
                    values.billingID, values.areaID, values.currentEnv, values.orgID);
            }
        }
    }

}
